module.exports = {"331102001":"紫金街道","331102002":"岩泉街道","331102003":"万象街道","331102004":"白云街道","331102007":"联城街道","331102008":"南明山街道","331102100":"碧湖镇","331102102":"大港头镇","331102103":"老竹畲族镇","331102104":"雅溪镇","331102200":"太平乡","331102201":"仙渡乡","331102202":"峰源乡","331102204":"丽新畲族乡","331102206":"黄村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331102.json
// module id = 1026
// module chunks = 0